import { motion } from "framer-motion";
import { Quotes } from "@phosphor-icons/react";

export const Story = () => {
  return (
    <section
      id="story"
      data-testid="story-section"
      className="relative bg-[#0a0705] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9 }}
            className="lg:col-span-5"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#E6CC98]" />
              <span className="text-xs uppercase tracking-[0.3em] gold-text font-body">
                The Founder
              </span>
            </div>
            <h2 className="font-heading font-light text-4xl sm:text-5xl tracking-tight text-[#FDFBF7] leading-[1.05]">
              A letter from
              <br />
              <span className="italic gold-gradient-text">Kim Monroe.</span>
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="lg:col-span-7"
          >
            <Quotes
              size={48}
              weight="thin"
              className="text-[#E6CC98] mb-6"
            />
            <p className="font-heading italic text-2xl sm:text-3xl text-[#FDFBF7] leading-snug font-light">
              "Hair is heritage. It carries memory, identity, and quiet
              defiance. I built Kim Monroe to give that heritage the home — and
              the hands — it deserved."
            </p>
            <div className="divider-gold my-10" />
            <div className="space-y-5 text-base sm:text-lg text-[#A39791] font-body leading-relaxed">
              <p>
                I started with a single chair, a small studio in the South, and
                a stubborn belief that women deserved better than mass-produced
                wigs shipped in from oceans away.
              </p>
              <p>
                A decade later, Kim Monroe LLC stands as proof: American
                craftsmanship is alive, it is exquisite, and it belongs in your
                wardrobe.
              </p>
            </div>
            <div className="mt-10 flex items-center gap-4">
              <div className="w-12 h-px bg-[#E6CC98]" />
              <div>
                <div className="font-heading text-lg text-[#FDFBF7]">
                  Kim Monroe
                </div>
                <div className="text-xs uppercase tracking-[0.25em] text-[#A39791] font-body">
                  Founder & Master Stylist
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
